var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.932,
    height: 25.094,
    viewBox: "0 0 19.932 25.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(-791.182 -421.341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 18.432,
    height: 23.594,
    rx: 1,
    transform: "translate(791.932 422.091)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 18.278,
    transform: "translate(792.086 426.804)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 5.713,
    cy: 5.713,
    r: 5.713,
    transform: "translate(795.415 430.187)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M855.487,473.859s-3.445,4.341,0,8.079",
    transform: "translate(-50.319 -41.998)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M811.514,501.741s.533-.626,1.139.33a.835.835,0,0,0,1.561,0c.223-.446.829-1.052,1.5-.159s1.243.657,1.593.121.669-.982,1.211-.44,1.06,1.052,1.454,1.02",
    transform: "translate(-15.887 -64.299)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    transform: "translate(803.472 423.444)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.122,
    cy: 1.122,
    r: 1.122,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.122,
    cy: 1.122,
    r: 0.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    transform: "translate(806.611 423.444)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.122,
    cy: 1.122,
    r: 1.122,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.122,
    cy: 1.122,
    r: 0.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 4.421,
    height: 1.368,
    rx: 0.684,
    transform: "translate(793.204 423.883)",
    fill: "#005682"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.1ce1f9086f07a7daf2cdd6180fb59e4f.svg";
export { ForwardRef as ReactComponent };